<template>
<div class="row">
    <div class="large-5 columns"> <img src="/static/imgs/28719-640-transp.png" alt=""> </div>
    <div class="large-7 columns top">
        <div class="panel">
            <div class="panel-title">
                Création de compte
                <hr>
            </div>
            <div class="panel-content" v-if="!requestSent && ( requestStatus === null || requestStatus !== 201 )">
                <!-- login -->
                <div class="row columns">
                    <div class="large-12 columns">
                        <label for="login">Identifiant </label>
                        <div class="notes">Mettez pas n'importe quoi, C'est le pseudo qui apparaîtra sur le site, et qui vous servira à vous connecter</div>
                        <div class="notes">min 3 caractères, pas de caractères spéciaux, pas d'espace</div>
                        <input type="text"
                               id="login"
                               placeholder="Identifiant"
                               name="login"
                               v-model="username"
                               v-on:blur="isLoginAvailable"
                               :class="{'valid': isLoginValid, 'invalid' : !isLoginValid }">
                        <div v-show="loginMinLengthError" class="is-danger">
                          <span><i class="fa fa-times" aria-hidden="true"></i></span>Nom d'utilisateur trop court, ou absent'
                        </div>
                        <div v-show="alphaNumericError" class="is-danger">
                          <span><i class="fa fa-times" aria-hidden="true"></i></span>On a dit que des caractères alphanumériques
                        </div>
                        <div v-show="loginAvailableError" class="is-danger">
                          <span><i class="fa fa-times" aria-hidden="true"></i></span>Nom d'utilisateur déjà pris
                        </div>
                    </div>
                </div>
                <!-- mot de passe -->
                <div class="row columns">
                    <div class="large-12 columns">
                        <label>Mot de passe</label>
                        <div class="notes">6 caractères minimum, ça vous fera les pieds.</div>
                        <input type="password"
                               id="pwd"
                               name="password"
                               placeholder="Mot de passe"
                               v-model="password"
                               :class="{'valid': !minLengthError, 'invalid':minLengthError }"
                               v-on:blur="checkPwd">
                          <div v-show="minLengthError" class="is-danger">
                            <span><i class="fa fa-times" aria-hidden="true"></i></span>On a dit 6 caractères minimum.
                          </div>
                    </div>
                </div>
                <!-- confirmation -->
                <div class="row columns">
                    <div class="large-12 columns">
                        <label>Confirmation du mot de passe</label>
                        <div class="notes">bien recommence.</div>
                        <input type="password"
                               id="confirm"
                               name="confirm"
                               placeholder="confirmation de Mot de passe"
                               v-model="confirm"
                               :class="{'valid': !pwdConfirmError, 'invalid':pwdConfirmError }"
                               v-on:blur="checkConfirm()">
                        <div v-show="pwdConfirmError" class="is-danger">
                          <span><i class="fa fa-times" aria-hidden="true"></i></span>le mot de passe et la confirmation ne collent pas
                        </div>
                    </div>
                </div>
                <!-- email -->
                <div class="row columns">
                    <div class="large-12 columns">
                        <label>Adresse email</label>
                        <div class="notes">Pour t'envoyer les millions de pub qui financent ma rolls rose en forme de guitare.</div>
                        <input type="email" name="email" id="email" placeholder="adresse email" v-model="email" :class="{'valid': !errors.has('email') && email != null}" v-validate="'required|email'">
                        <div v-show="errors.has('email')" class="is-danger"> <span><i class="fa fa-times" aria-hidden="true"></i></span> {{ errors.first('email') }} </div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row columns">
                    <div class="large-4 columns">
                        <router-link to="/home">
                            <button class="full-width light-grey-button">Retour</button>
                        </router-link>
                    </div>
                    <div class="large-4 columns">
                        <button :disabled="!submissionEnabled" class="full-width" @click="createAccount" type="submit">Valider</button>
                    </div>
            </div>
        </div>
        <div v-if="requestSent" class="panel-content">
            <spinner></spinner>
        </div>
        <div v-if="requestStatus === 201" class="panel-content">
            <div class="row columns">
                <div class="large-12 columns">
                   <h2>Hiiihaaaaa !! </h2>
                    <div>Votre compte est créé ! vous êtes connecté. Bienvenue.</div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="large-4 columns large-centered">
                    <router-link to="/home"><button class="full-width" type="submit">Aller à l'accueil</button></router-link>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
import user from '../../api/user.api'
import spinner from '../common/spinner.vue'
import store from '../../store/index.js'

export default {
  name: 'createAccount',
  components: {
    spinner
  },
  computed:
  {
    submissionEnabled: function () {
      if (this.isLoginValid && this.isPwdValid && !this.pwdConfirmError) {
        return true
      }
      return false
    },
    isLoginValid: function () {
      return !this.loginMinLengthError && !this.alphaNumericError && !this.loginAvailableError
    },
    isPwdValid: function () {
      return !this.minLengthError
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
  },
  data () {
    return {
      username: '',
      email: '',
      password: '',
      confirm: '',
      requestSent: false,
      availabilityRequest: null,
      requestStatus: null,
      // errors
      minLengthError: false,
      loginMinLengthError: false,
      pwdConfirmError: false,
      alphaNumericError: false,
      loginAvailableError: false
    }
  },
  methods: {
    checkPwd () {
      this.minLengthError = false
      if (this.password !== '' && this.password.length < 6) {
        this.minLengthError = true
      }
    },
    checkConfirm () {
      this.pwdConfirmError = false
      if (this.password !== this.confirm || this.confirm === '') {
        this.pwdConfirmError = true
      }
    },
    isLoginAvailable (event) {
      this.loginMinLengthError = false
      this.alphaNumericError = false
      this.loginAvailableError = false
      if (this.username !== '' && this.username.length < 3) {
        this.loginMinLengthError = true
        return
      }
      var striped = this.username.replace(/[^a-z0-9]/gi, '')
      if (striped.length !== this.username.length) {
        this.alphaNumericError = true
        return
      }
      user.api.isLoginExisting(this.username)
      .then(response => {
        this.availabilityRequest = response.status
      },
      error => {
        if (error.status === 406) {
          this.loginAvailableError = true
        } else {
          this.errors.add('login', 'impossible de vérifier la disponibilité de ce pseudo ', 'request')
          this.errors.first('login:request')
        }
      })
    },
    createAccount () {
      if (this.errors.has('password') || this.password === null) {
        return
      }
      this.requestSent = true

      user.api.createUser(this.username, this.password, this.confirm, this.email)
      .then(response => {
        this.requestSent = false
        this.requestStatus = response.status
        console.log(response.data.key)
        store.dispatch('directLogin', response.data.key)
      },
      error => {
        this.requestSent = false
        console.log(error)
        this.errors.add('password', 'impossible d\'éxécuter la requeête, vérifiez la connexion', 'request')
        this.errors.first('password:request')
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-error {
  text-align: center;
  color: #CC0000;
}

.form-group {
  border-radius: 8px;
}

.notes {
  font-size: 0.7rem;
  font-weight: 300;
  color: #2F353B;
  text-align: left;
}

label {
  font-size: 1rem;
  color: #2F353B;
  font-weight: 500;
  text-align: left;
}

.is-danger {
  color:#E7505A;
}

.message {
  margin-top: 0.4rem;
  margin-left: 0rem;
  padding-left: 0rem;
  font-size: 0.9rem;
  text-align: left;
}

input.invalid{
  border-left: 3px solid #a94442;
}

input.valid{
  border-left: 3px solid #42A948; /* green */
}

input.untouched{
  border-left: 3px solid #ACB5C3;
}
</style>



// WEBPACK FOOTER //
// create-account.vue?87dd9b50